module.exports = __webpack_public_path__ + "static/frame-tenango-356a081a7fac2dbac8b48f99768f8627.png";